import React from 'react';

import {IEntityMeta} from 'entities/metadata';
import {performActionForForm} from 'modules/data/data-actions';
import {IFormEntityData} from 'modules/data/data-types';
import {ERequestType} from 'shared/types/requests';
import {useAppDispatch} from 'store/config/hooks';

import {Form} from '../form';

import './form-page.less';

interface IFormPageProps {
    entityName: string;
    formData?: IFormEntityData;
    metadata?: IEntityMeta;
    onClose: () => void;
}

export const FormPage = ({
    entityName, formData, metadata, onClose,
}: IFormPageProps) => {
    const dispatch = useAppDispatch();
    const handleFormSubmit = (
        // eslint-disable-next-line @typescript-eslint/no-shadow
        entityName: string,
        referenceUrl: string,
        requestType: ERequestType,
        newData: Record<string, any>,
        isJsonRequest?: boolean,
    ) => dispatch(performActionForForm()(
        entityName, referenceUrl, requestType, newData, isJsonRequest,
    ));

    return (
        <div className="form-page">
            {formData?.data?.disabledFormFlag ? (
                <div className="form-placeholder">{formData.data?.disabledFormMessage || 'Error'}</div>
            ) : (
                <Form
                    formData={formData}
                    meta={metadata}
                    entityName={entityName}
                    onClose={onClose}
                    actionForForm={handleFormSubmit}
                />
            )}
        </div>
    );
};
